import FunnelChart from './FunnelChart'
import GenericChart from './GenericChart'
import GaugeChart from './GaugeChart'

export default {
  FunnelChart,
  GenericChart,
  GaugeChart,
}
